/* eslint-disable */
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  Input,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  makeStyles,
} from '@material-ui/core';
import React from 'react';
import PopupMultiDropDown from './PopupMultiDropDown';
import { MultiSelectDropdown } from './MultiSelectDropdown';

const useStyle = makeStyles({
  filterContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '98%',
    gap: '30px',
    marginTop: '5px',
    padding: '10px',
    paddingLeft: '0px',
    boxSizing: 'border-box',
  },
  left: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '90%',
    gap: '5px 30px',
    flexWrap: 'wrap',
  },
  editButton: {
    height: '40px',
    width: '100px',
    marginRight: '10px',
  },
  count: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '7px',
    transform: 'translateY(-50%)',
    background: '#622FEE',
    color: '#fff',
    fontWeight: '500',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '99',
  },
  selectDropdown: {
    height: '40px',
    width: '250px',
    paddingLeft: '40px',
    borderRadius: '7px',
  },
});

export const PxFilters = ({
  appliedFilters,
  setAppliedFilters,
  DEFAULT_FILTERS,
  filters,
  onFilter,
  onApplyAll,
  showApplyAll = false,
}) => {
  const classes = useStyle();

  const handleFilterChange = (name, value) => {
    if (name === 'salesPipelineStatus') {
      if (value.length === 0) {
        setAppliedFilters((app) => ({
          ...app,
          salesPipelineStatus: DEFAULT_FILTERS.salesPipelineStatus,
        }));
      } else {
        setAppliedFilters((app) => ({
          ...app,
          salesPipelineStatus: value,
        }));
      }
    } else if (name === 'source') {
      if (value.length === 0) {
        setAppliedFilters((app) => ({
          ...app,
          source: ['ADMIN'],
        }));
      } else {
        setAppliedFilters((app) => ({
          ...app,
          source: value,
        }));
      }
    } else if (name === 'dealerGroup') {
      setAppliedFilters((app) => ({
        ...app,
        dealerGroup: value,
      }));
    } else if (name === 'pxOwners') {
      setAppliedFilters((app) => ({
        ...app,
        pxOwners: value,
      }));
    } else if (name === 'plans') {
      setAppliedFilters((app) => ({
        ...app,
        plans: value,
      }));
    } else {
      setAppliedFilters((app) => ({
        ...app,
        [name]: value,
      }));
    }
  };

  const handleAllSourcesToggle = (isCheck) => {
    if (isCheck) {
      setAppliedFilters((app) => ({
        ...app,
        source: filters?.source || [],
      }));
    } else {
      setAppliedFilters((app) => ({
        ...app,
        source: ['ADMIN'],
      }));
    }
  };

  const handleAllDealerToggle = (isCheck) => {
    if (isCheck) {
      setAppliedFilters((app) => ({
        ...app,
        dealerGroup: filters?.dealerGroup?.map((item) => item),
      }));
    } else {
      setAppliedFilters((app) => ({
        ...app,
        dealerGroup: DEFAULT_FILTERS.dealerGroup,
      }));
    }
  };

  const handleAllPxOwnerToggle = (isCheck) => {
    if (isCheck) {
      setAppliedFilters((app) => ({
        ...app,
        pxOwners: filters?.pxOwners?.map((item) => item),
      }));
    } else {
      setAppliedFilters((app) => ({
        ...app,
        pxOwners: [],
      }));
    }
  };

  const handleAllPlansToggle = (isCheck) => {
    if (isCheck) {
      setAppliedFilters((app) => ({
        ...app,
        plans: filters?.plans?.map((item) => item),
      }));
    } else {
      setAppliedFilters((app) => ({
        ...app,
        plans: DEFAULT_FILTERS.plans,
      }));
    }
  };

  const handleAllPipelineStatus = (e) => {
    const isCheck = e.target.checked;
    if (isCheck) {
      setAppliedFilters((app) => ({
        ...app,
        salesPipelineStatus: filters?.salesPipelineStatus?.map((item) => item),
      }));
    } else {
      setAppliedFilters((app) => ({
        ...app,
        salesPipelineStatus: DEFAULT_FILTERS.salesPipelineStatus,
      }));
    }
  };

  return (
    <Grid className={classes.filterContainer}>
      <Grid className={classes.left}>
        <MultiSelectDropdown
          selectedData={appliedFilters?.source || []}
          data={filters?.source || []}
          onChangeFilter={handleFilterChange}
          onSelectedAllToggle={handleAllSourcesToggle}
          name="source"
          filedTitle="Source"
        />

        <MultiSelectDropdown
          selectedData={appliedFilters?.dealerGroup || []}
          data={filters?.dealerGroup || []}
          onChangeFilter={handleFilterChange}
          onSelectedAllToggle={handleAllDealerToggle}
          name="dealerGroup"
          filedTitle="Dealer Group"
          isSearchable
        />

        <Grid>
          <FormControl>
            <Grid style={{ position: 'relative' }}>
              {appliedFilters.salesPipelineStatus?.length >= 1 && (
                <Grid className={classes.count}>{appliedFilters.salesPipelineStatus?.length}</Grid>
              )}

              <Select
                style={
                  appliedFilters.pxOwners?.length >= 1
                    ? { background: '#F4F3FF', border: '1px solid #D9D6FE' }
                    : { background: '#FFFFFF' }
                }
                className={classes.selectDropdown}
                value={appliedFilters.salesPipelineStatus?.map((i) => i?.title) || []}
                onChange={(e) => {
                  const selectedItems = e.target.value;
                  const len = selectedItems?.length;
                  if (selectedItems[len - 1] !== 'all') {
                    const salesPipelineStatus = selectedItems.map((val) => {
                      const arr = filters?.salesPipelineStatus?.filter((item) => item.title === val);
                      return arr[0];
                    });
                    handleFilterChange('salesPipelineStatus', salesPipelineStatus);
                  } else if (appliedFilters.salesPipelineStatus.length === filters?.salesPipelineStatus?.length) {
                    setAppliedFilters((app) => ({
                      ...app,
                      salesPipelineStatus: DEFAULT_FILTERS.salesPipelineStatus,
                    }));
                  } else {
                    setAppliedFilters((app) => ({
                      ...app,
                      salesPipelineStatus: filters?.salesPipelineStatus?.map((item) => item),
                    }));
                  }
                }}
                input={<Input disableUnderline className={classes.textfield} />}
                displayEmpty
                renderValue={() => 'Sales Pipeline Status'}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5 + 8,
                      width: 310,
                    },
                  },
                }}
                multiple
              >
                <MenuItem key="all" name="all" value="all">
                  <Checkbox
                    color="primary"
                    checked={appliedFilters?.salesPipelineStatus?.length === filters?.salesPipelineStatus?.length}
                    onChange={handleAllPipelineStatus}
                  />
                  <ListItemText primary="All" />
                </MenuItem>

                {filters?.salesPipelineStatus?.map((sl) => (
                  <MenuItem key={`${sl.id}-${sl.title}`} name={sl.id} value={sl.title}>
                    <Checkbox
                      color="primary"
                      checked={appliedFilters.salesPipelineStatus?.some((el) => el?.id === sl.id)}
                    />
                    <ListItemText style={{ whiteSpace: 'normal' }} primary={sl.title} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </FormControl>
        </Grid>

        <MultiSelectDropdown
          selectedData={appliedFilters?.pxOwners || []}
          data={filters?.pxOwners || []}
          onChangeFilter={handleFilterChange}
          onSelectedAllToggle={handleAllPxOwnerToggle}
          name="pxOwners"
          filedTitle="Px Owner"
        />

        <MultiSelectDropdown
          selectedData={appliedFilters?.plans || []}
          data={filters?.plans || []}
          onChangeFilter={handleFilterChange}
          onSelectedAllToggle={handleAllPlansToggle}
          name="plans"
          filedTitle="Plan"
        />
      </Grid>
      <Grid style={{ width: showApplyAll ? '20%' : '10%', display: 'flex', gap: '10px' }}>
        <Button
          variant="contained"
          color="primary"
          focusRipple={false}
          className={classes.editButton}
          onClick={onFilter}
        >
          Apply
        </Button>
        {showApplyAll && onApplyAll && (
          <Button
            variant="contained"
            color="primary"
            focusRipple={false}
            className={classes.editButton}
            onClick={onApplyAll}
          >
            Apply All
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
